export default function formatPrice(number) {
  if (number === null) {
    return '';
  }

  return number.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ');
}

